<template>
  <v-layout row wrap>
    <v-flex xs12 md12>
        <div class="pie-wrapper">
        <h1 class="top-text">Today</h1>
        <div class="pie" :style='bggradientDay'
            @click="bggradient = bggradientDay,
            wrapper2Text='Today\'s Sales',
            salesOnClick = sales.today,userwiseSales = userwiseSalesDay,
            sentToCustomersOrders = sentToCustomersOrdersDay,
            processingOrders = processingOrdersDay,
            pieClicked = 'Day',
            showDetails= true
            "
            :class="pieClicked === 'Day' ? 'pieClicked' : ''"
            >
            <div class="txt">
            <span v-if="!loadingToday">{{sentToCustomersOrdersDay + processingOrdersDay}}</span>
            <v-layout justify-center align-center v-if="loadingToday">
                <v-progress-circular
                indeterminate
                color="primary">
                </v-progress-circular>
            </v-layout>
            </div>
        </div>
        </div>
        <div class="pie-wrapper">
        <h1 class="top-text">WTD</h1>
        <div class="pie" :style='bggradientWeek'
            @click="bggradient = bggradientWeek,
            wrapper2Text='WTD Sales',
            salesOnClick = sales.week,
            userwiseSales = userwiseSalesWeek,
            sentToCustomersOrders = sentToCustomersOrdersWeek,
            processingOrders = processingOrdersWeek,
            pieClicked = 'Week',
            showDetails= true
        "
        :class="pieClicked === 'Week' ? 'pieClicked' : ''"
        >
            <div class="txt">
            <span v-if="!loadingWeek">{{sentToCustomersOrdersWeek + processingOrdersWeek}}</span>
            <v-layout justify-center align-center v-if="loadingWeek">
                <v-progress-circular
                indeterminate
                color="primary">
                </v-progress-circular>
            </v-layout>
            </div>
        </div>
        </div>
        <div class="pie-wrapper">
        <h1 class="top-text">MTD</h1>
        <div class="pie" :style='bggradientMonth'
            @click="bggradient = bggradientMonth,
            wrapper2Text='MTD Sales',
            salesOnClick = sales.month,
            userwiseSales = userwiseSalesMonth,
            sentToCustomersOrders = sentToCustomersOrdersMonth,
            processingOrders = processingOrdersMonth,
            pieClicked = 'Month',
            showDetails= true
        "
        :class="pieClicked === 'Month' ? 'pieClicked' : ''"
        >
            <div class="txt">
            <span v-if="!loadingMonth">{{sentToCustomersOrdersMonth + processingOrdersMonth}}</span>
            <v-layout justify-center align-center v-if="loadingMonth">
                <v-progress-circular
                indeterminate
                color="primary">
                </v-progress-circular>
            </v-layout>
            </div>
        </div>
        </div>
        <div class="pie-wrapper">
        <h1 class="top-text">QTD</h1>
        <div class="pie" :style='bggradientQuarter'
            @click="bggradient = bggradientQuarter,
            wrapper2Text='QTD Sales',
            salesOnClick = sales.quarter,
            userwiseSales = userwiseSalesQuarter,
            sentToCustomersOrders = sentToCustomersOrdersQuarter,
            processingOrders = processingOrdersQuarter,
            pieClicked = 'Quarter',
            showDetails= true
        "
        :class="pieClicked === 'Quarter' ? 'pieClicked' : ''"
        >
            <div class="txt">
            <span v-if="!loadingQuarter">{{sentToCustomersOrdersQuarter + processingOrdersQuarter}}</span>
            <v-layout justify-center align-center v-if="loadingQuarter">
                <v-progress-circular
                indeterminate
                color="primary">
                </v-progress-circular>
            </v-layout>
            </div>
        </div>
        </div>
        <div class="pie-wrapper">
        <h1 class="top-text">YTD</h1>
        <div class="pie" :style='bggradientYear'
            @click="bggradient = bggradientYear,
            wrapper2Text='YTD Sales',
            salesOnClick = sales.year,
            userwiseSales = userwiseSalesYear,
            sentToCustomersOrders = sentToCustomersOrdersYear,
            processingOrders = processingOrdersYear,
            pieClicked = 'Year',
            showDetails= true
        "
        :class="pieClicked === 'Year' ? 'pieClicked' : ''"
        >
            <div class="txt">
            <span v-if="!loadingYear">{{sentToCustomersOrdersYear + processingOrdersYear}}</span>
            <v-layout justify-center align-center v-if="loadingYear">
                <v-progress-circular
                indeterminate
                color="primary">
                </v-progress-circular>
            </v-layout>
            </div>
        </div>
        </div>
    </v-flex>
  </v-layout>
</template>

<script>
import OrderService from '@/services/OrderService'
export default {
  props: {
    outStandingSales: String
  },
  data: () => ({
    loggedInUser: JSON.parse(atob(localStorage.getItem('user'))),
    showDetails: false,
    fcEvents: [],
    value: [],
    ordersImport: '',
    span: 7,
    sales: {
      today: '$0',
      week: '$0',
      month: '$0',
      quarter: '$0',
      year: '$0'
    },
    pieClicked: '',
    salesOnClick: '',
    wrapper2Text: 'Today\'s Sales',
    orderDetails: [],
    userwiseSales: {},
    userwiseSalesDay: {},
    userwiseSalesWeek: {},
    userwiseSalesMonth: {},
    userwiseSalesQuarter: {},
    userwiseSalesYear: {},
    loadingToday: true,
    loadingWeek: true,
    loadingQuarter: true,
    loadingMonth: true,
    loadingYear: true,
    loadingOrderOverview: true,
    notToShowStatuses: [null, 'Need to Book Check Measure', 'Cart', 'Pending'],
    processingOrdersDay: 0,
    sentToCustomersOrdersDay: 0,
    processingOrdersWeek: 0,
    sentToCustomersOrdersWeek: 0,
    processingOrdersMonth: 0,
    sentToCustomersOrdersMonth: 0,
    processingOrdersQuarter: 0,
    sentToCustomersOrdersQuarter: 0,
    processingOrdersYear: 0,
    sentToCustomersOrdersYear: 0,
    processingOrders: 0,
    sentToCustomersOrders: 0,
    bggradient: 'background-image: conic-gradient(#e0e0e0 50%, #e0e0e0 50%)',
    bggradientDay: 'background-image: conic-gradient(#e0e0e0 50%, #e0e0e0 50%)',
    bggradientWeek: 'background-image: conic-gradient(#e0e0e0 50%, #e0e0e0 50%)',
    bggradientQuarter: 'background-image: conic-gradient(#e0e0e0 50%, #e0e0e0 50%)',
    bggradientMonth: 'background-image: conic-gradient(#e0e0e0 50%, #e0e0e0 50%)',
    bggradientYear: 'background-image: conic-gradient(#e0e0e0 50%, #e0e0e0 50%)',
    showDashboard: true
  }),
  computed: {
    filteredOrderDetails () {
      return this.orderDetails.filter(o => !(this.notToShowStatuses.indexOf(o._id) > -1))
    }
  },
  async mounted () {
    this.getSamplesDataToday()
    this.getSamplesDataWeek()
    this.getSamplesDataMonth()
    this.getSamplesDataQuarter()
    this.getSamplesDataYear()
  },
  methods: {
    async getSamplesDataToday () {
      let todayResponse = await OrderService.getTodaySamples()
      // if (todayResponse.data.todayTotal !== 0) {
      //   this.sales.today = '$' + parseFloat(todayResponse.data.todayTotal.toFixed(2)).toLocaleString()
      // } else {
      //   this.sales.today = '$0'
      // }
      // this.salesOnClick = this.sales.today
      this.calculatePerc(todayResponse.data.orders, 'today')
      this.loadingToday = false
    },
    async getSamplesDataWeek () {
      let weekResponse = await OrderService.getWeekSamples()
      // if (weekResponse.data.weekTotal !== 0) {
      //   this.sales.week = '$' + parseFloat(weekResponse.data.weekTotal.toFixed(2)).toLocaleString()
      // } else {
      //   this.sales.week = '$0'
      // }
      this.calculatePerc(weekResponse.data.orders, 'week')
      this.loadingWeek = false
    },
    async getSamplesDataMonth () {
      let monthResponse = await OrderService.getMonthSamples()
      // if (monthResponse.data.monthTotal !== 0) {
      //   this.sales.month = '$' + parseFloat(monthResponse.data.monthTotal.toFixed(2)).toLocaleString()
      // } else {
      //   this.sales.month = '$0'
      // }
      this.calculatePerc(monthResponse.data.orders, 'month')
      this.loadingMonth = false
    },
    async getSamplesDataQuarter () {
      let quarterResponse = await OrderService.getQuarterSamples()
      // if (quarterResponse.data.quarterTotal !== 0) {
      //   this.sales.quarter = '$' + parseFloat(quarterResponse.data.quarterTotal.toFixed(2)).toLocaleString()
      // } else {
      //   this.sales.quarter = '$0'
      // }
      this.calculatePerc(quarterResponse.data.orders, 'quarter')
      this.loadingQuarter = false
    },
    async getSamplesDataYear () {
      let yearResponse = await OrderService.getYearSamples()
      // if (yearResponse.data.yearTotal !== 0) {
      //   this.sales.year = '$' + parseFloat(yearResponse.data.yearTotal.toFixed(2)).toLocaleString()
      // } else {
      //   this.sales.year = '$0'
      // }
      this.calculatePerc(yearResponse.data.orders, 'year')
      this.loadingYear = false
    },
    async calculatePerc (orders, dataOf) {
      let processingOrders = orders.filter(function (order) {
        return order.status === 'Processing'
      })
      let sentToCustomersOrders = orders.filter(function (order) {
        return order.status === 'Sent to Customer'
      })
      let totalOrders = processingOrders.length + sentToCustomersOrders.length
      let firstColor = processingOrders.length / totalOrders * 100
      let secondColor = 100 - firstColor
      secondColor = 0.1 // second color will be auto set
      if (dataOf === 'today') {
        this.bggradientDay = `background-image: conic-gradient(#565e6f ${firstColor}%, #ea4d76 ${secondColor}%)`
        if (firstColor === 0) {
          this.bggradientDay = `background-image: conic-gradient(#ea4d76 ${firstColor}%, #ea4d76 ${secondColor}%)`
        } else if (secondColor === 0) {
          this.bggradientDay = `background-image: conic-gradient(#565e6f ${firstColor}%, #565e6f ${secondColor}%)`
        }
        // this.bggradient = this.bggradientDay
        this.processingOrdersDay = processingOrders.length
        this.sentToCustomersOrdersDay = sentToCustomersOrders.length
        // this.processingOrders = processingOrders.length
        // this.sentToCustomersOrders = sentToCustomersOrders.length
        // this.userwiseSales = userwiseSales
      } else if (dataOf === 'week') {
        this.bggradientWeek = `background-image: conic-gradient(#565e6f ${firstColor}%, #ea4d76 ${secondColor}%)`
        if (firstColor === 0) {
          this.bggradientWeek = `background-image: conic-gradient(#ea4d76 ${firstColor}%, #ea4d76 ${secondColor}%)`
        } else if (secondColor === 0) {
          this.bggradientWeek = `background-image: conic-gradient(#565e6f ${firstColor}%, #565e6f ${secondColor}%)`
        }
        this.processingOrdersWeek = processingOrders.length
        this.sentToCustomersOrdersWeek = sentToCustomersOrders.length
      } else if (dataOf === 'month') {
        this.bggradientMonth = `background-image: conic-gradient(#565e6f ${firstColor}%, #ea4d76 ${secondColor}%)`
        if (firstColor === 0) {
          this.bggradientMonth = `background-image: conic-gradient(#ea4d76 ${firstColor}%, #ea4d76 ${secondColor}%)`
        } else if (secondColor === 0) {
          this.bggradientMonth = `background-image: conic-gradient(#565e6f ${firstColor}%, #565e6f ${secondColor}%)`
        }
        this.processingOrdersMonth = processingOrders.length
        this.sentToCustomersOrdersMonth = sentToCustomersOrders.length
      } else if (dataOf === 'quarter') {
        this.bggradientQuarter = `background-image: conic-gradient(#565e6f ${firstColor}%, #ea4d76 ${secondColor}%)`
        if (firstColor === 0) {
          this.bggradientQuarter = `background-image: conic-gradient(#ea4d76 ${firstColor}%, #ea4d76 ${secondColor}%)`
        } else if (secondColor === 0) {
          this.bggradientQuarter = `background-image: conic-gradient(#565e6f ${firstColor}%, #565e6f ${secondColor}%)`
        }
        this.processingOrdersQuarter = processingOrders.length
        this.sentToCustomersOrdersQuarter = sentToCustomersOrders.length
      } else if (dataOf === 'year') {
        this.bggradientYear = `background-image: conic-gradient(#565e6f ${firstColor}%, #ea4d76 ${secondColor}%)`
        if (firstColor === 0) {
          this.bggradientYear = `background-image: conic-gradient(#ea4d76 ${firstColor}%, #ea4d76 ${secondColor}%)`
        } else if (secondColor === 0) {
          this.bggradientYear = `background-image: conic-gradient(#565e6f ${firstColor}%, #565e6f ${secondColor}%)`
        }
        this.processingOrdersYear = processingOrders.length
        this.sentToCustomersOrdersYear = sentToCustomersOrders.length
      }
      // //
    }
  },
  components: {
  }
}
</script>

<style scoped>
.link {
  cursor: pointer;
}
.link:hover {
  opacity: 0.7
}
.event-box {
    padding: 25px;
}
.m0a {
  margin: 0 auto;
}
.pie-wrapper {
  width: 20%;
  float: left;
}
.pie {
  width: 250px;
  height: 250px;
  max-width: 100%;
  max-height: 100%;
  background-image: conic-gradient(#ea4d76 50%, #565e6f 50%);
  border-radius: 50%;
  position: relative;
  margin: 0 auto;
  cursor: pointer;
}
.pieClicked {
  border: 5px green solid;
  background: #fff;
  background-image: none !important;
}
.pieClicked .txt {
  color: green !important;
}
.pie-wrapper2 .pie {
  width: 350px;
  height: 350px;
}
.pie .txt {
  position: absolute;
  color: #fff;
  font-size: 40px;
  font-weight: bold;
  width: 100px;
  text-align: center;
  width: 100%;
  top: 38%;
}
.pie .txt2 {
  top: 15%;
  font-size: 16px;
  left: 18%;
}
.pie .txt3 {
  top: 10%;
}
/* .pie .txt2 > div {
  float: left;
} */
.top-text {
  text-align: center;
  color: #ea4d76;
  margin: 20px;
}
.top-text2 {
  color: #565e6f;
  margin-bottom: 20px;
}
.tb {
  content: '';
  border-bottom: 4px solid #ea4d76;
  height: 175px;
  width: calc(100% - 60px);
  margin-left: 30px;
}
@media screen and (max-width: 661px) {
  .pie-wrapper {
    width: 100%;
    float: left;
  }
  .top-text2 {
    text-align: center;
  }
  .tb {
    height: 25px;
    border-right: 4px solid #ea4d76;
    margin: 0 auto;
    width: 4px;
    border-bottom: none;
  }
  .pie-wrapper2 .pie[data-v-aae30ed8] {
    max-width: 290px;
    max-height: 290px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SamplesDashboard.vue